import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Typography from '@material-ui/core/Typography'

import Snackbar from '@material-ui/core/Snackbar'
import Fade from '@material-ui/core/Fade'

import { connect } from 'react-redux'

import { handleSubmitProposal } from '../actions/rfp'
import t from '../utils/lang'

const styles = theme => ({
  root: {
    width: '100%'
  },
  sendInfo: {
    fontSize: theme.typography.pxToRem(16),
  }
});

class SubmitDialog extends Component {
  state = {
    snackbarOpen: false,
  }

  componentDidMount() {}

  handleSendProposal = e => {
    const { rfpId, handleClose, dispatch } = this.props

    dispatch(handleSubmitProposal(rfpId))

    handleClose()
    this.handleOpenSnackbar()
  }

  handleOpenSnackbar = () => {
    this.setState({ snackbarOpen: true })
  }

  handleCloseSnackbar = () => {
    this.setState({ snackbarOpen: false })
  }

  render() {
    const { snackbarOpen } = this.state
    const { fullScreen, open, handleClose, classes, lang } = this.props

    return (
      <div className={classes.root}>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">{t[lang].submitProposal}</DialogTitle>
          <DialogContent>
            <Typography className={classes.sendInfo}>
              {t[lang].submitProposalInfo}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              {t[lang].cancel}
            </Button>
            <Button onClick={this.handleSendProposal} color="primary" autoFocus>
              {t[lang].send}
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={snackbarOpen}
          onClose={this.handleCloseSnackbar}
          TransitionComponent={Fade}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{t[lang].proposalSubmittedMessage}</span>}
        />
      </div>
    );
  }
}

SubmitDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  //rfpId: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
}

function mapStateToProps ({ rfpData }) {
  return {
    rfpId: rfpData.id
  }
}

export default connect(mapStateToProps)(withStyles(styles)(withMobileDialog()(SubmitDialog)))


// WEBPACK FOOTER //
// ./src/components/SubmitDialog.js